





































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { SitesApi } from '../../api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component({
	components: { VueSelect },
})
export default class SiteSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	public collapseVisible = true;

	@PropSync('site') public localSite!: object;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Boolean)
	public readonly state?: boolean;

	public options = [];
	private api: SitesApi;

	constructor() {
		super();
		this.api = new SitesApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public mounted() {
		if (this.localSite === null) {
			this.localSite = { name: null };
		}
	}
	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.collapseVisible = !this.collapseVisible;
		this.localSite = {
			...item,
			address: {
				fullAdr: item.address ? item.address.fullAdr : '',
				region: item.address ? item.address.region : '',
				location: item.latitude && item.longitude ? `${item.latitude}, ${item.longitude}` : null,
			} || {
				fullAdr: '',
				region: '',
				location: '',
			},
		};
		this.$emit('exist', true);
	}

	public onSearch(search: string) {
		this.collapseVisible = true;
		if (!search || search.length < 1) {
			this.debouncedOptions.cancel();
			return;
		}
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public clearSite() {
		this.localSite.name = '';
		this.localSite = {
			id: undefined,
			name: '',
			address: { fullAdr: '', region: '', location: '' },
		};
		this.$emit('exist', false);
	}

	public async fetchOptions(search: string) {
		const options = {
			params: {
				include: 'address',
				'filter[name]': search,
				'fields[sites]': 'id,name,latitude,longitude,orgId',
			},
		};
		const response = await this.api.getSites(options);
		this.options = response.data.data || [];
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
